<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <h2 class="heading-2 align-left">Client Reference Number</h2>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert  :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready && !set">
            <v-form ref="form" v-model="valid" lazy-validation @submit="updateClientRefNo">
              
              <v-layout row>
                <v-flex xs12>
                  <v-text-field outline v-model="clientRefNo" :rules="clientRefRules" label="Client Reference Number" ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row align-center mx-1>
                <v-spacer />
                <button type="submit" class="button" :disabled="!valid || !ready" color="success" >Save Client Reference</button>
              </v-layout>

            </v-form>
          </template>
          <template v-else-if="set">
            <v-form ref="form"  lazy-validation @submit="resetClientRefNo">
              
              <v-layout row>
                <v-flex xs12>
                  <v-text-field outline v-model="clientRefNo"  label="Client Reference Number" readonly></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row align-center mx-1>
                <v-spacer />
                <button type="submit" class="button" color="success" >Unlink Client Reference</button>
              </v-layout>

            </v-form>
          </template>
           <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
                :size="50"
                color="accent"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>

        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'UserProfile',
  data () {
    
    return {
      ready: false,
      valid: true,
      clientRefRules: [
        v => (v && v.length >3 && v.length < 10) || 'Client Reference Number should be between 4 and 9 digits',
      ],
      firstName: '',
      lastName: '',
      set: false,
      clientRefNo: null,
      clientRefNoOriginal: null,
      error: null,
      success: null,
      loading: false
    }
  },
  created () {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {
      this.firstName = userData.given_name
      this.lastName = userData.family_name
      this.clientRefNo = userData['custom:client_ref_no']
      if(this.clientRefNo){
          this.set = true
      }
      this.clientRefNoOriginal = userData['custom:client_ref_no']
      // tell the app that we've finished loading
      this.ready = true
    }, 
    (err)=> {
        console.log('Unable to load user profile, session may not be present.')
    });
    
  },
  methods: {
    updateClientRefNo (e) {
        e.preventDefault()
        this.ready = false
        var vm = this
        //get latest names for validation checks
        this.$getCurrentUserAttributes().subscribe((userData) => {
            this.firstName = userData.given_name
            this.lastName = userData.family_name
            
            this.$getSession().subscribe((sessionData) => {
            
            const httpOptions = {
              headers:{
                'Content-Type':  'application/json',
                'Authorization': String(sessionData.idToken.jwtToken)
              }
            }
            
            axios.get(`${process.env.VUE_APP_TEAMCARD_API}/validate?firstName=${vm.firstName}&lastName=${vm.lastName}&clientRefNo=${this.clientRefNo}`, httpOptions ).then(function (teamCardResponse) {
              if (teamCardResponse.data.valid === true) {
                // console.log(teamCardResponse.data)
                var attributesList = {
                    "custom:client_ref_no": vm.clientRefNo
                }
                
                vm.$updateAttributes(attributesList).subscribe((response) => {
                  console.log("update successful")
                  vm.error = null
                  vm.success = response
                  vm.ready = true
                  vm.set = true
                  }, 
                  (err)=> {
                    //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
                    console.log(err.message)
                    vm.success = null
                    vm.error = err
                    vm.ready = true
                });   
              } else {
                vm.error = {message: 'You have specified a new client reference number but we were unable to verify the code.'}
                vm.success = null
                // console.log('error', teamCardResponse.data)
                vm.ready = true
              }
            }).catch(function (error) {
              vm.error = {message: 'You have specified a new client reference number but we were unable to verify, therefore your client reference number has not been saved.'}
              vm.success = null
              // console.log('error',error)
              vm.ready = true
            })

          }), 
          (err)=> {
              console.log('Unable get user session.')
          }






        }, 
        (err)=> {
            console.log('Unable to load user profile, session may not be present.')
        });

    
    },
    resetClientRefNo (e) {
        e.preventDefault()
        this.ready = false
        
        var attributesList = {
             "custom:client_ref_no":''
        }
                
        this.$updateAttributes(attributesList).subscribe((response) => {
                console.log("update successful")
                this.error = null
                this.success = response
                this.ready = true
                this.set = false
                this.clientRefNo = ''
            }, 
            (err)=> {
                //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
                console.log(err.message)
                this.success = null
                this.error = err
                this.ready = true
            })    
    }
  }
}
</script>

<style scoped>
</style>